import { render } from "./RecoverPassword.vue?vue&type=template&id=d404c3b0&scoped=true&ts=true"
import script from "./RecoverPassword.vue?vue&type=script&lang=ts"
export * from "./RecoverPassword.vue?vue&type=script&lang=ts"

import "./RecoverPassword.vue?vue&type=style&index=0&id=d404c3b0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d404c3b0"]])

export default __exports__